<sd-generic-link
  *ngIf="component.data$ | async as data"
  [url]="data.url"
  [style]="data.styleAttributes"
  [target]="getTarget(data)"
>
  <ng-container *ngIf="data.media">
    <cx-media [container]="data.media"></cx-media>
  </ng-container>

  <span *ngIf="data.linkName">{{ data.linkName }}</span>
</sd-generic-link>
